import { Action } from "@ngrx/store";
import { TransactionDetailDto } from "@admin_api/models/transaction-detail-dto";

export enum ActionTypes {
    GetTransactionSiblingsDetail = "[Transaction Siblings] GetTransactionSiblingsDetail",
    GetTransactionSiblingsDetailSucceed = "[Transaction Siblings] GetTransactionSiblingsDetailSucceed",
    GetTransactionSiblingsDetailFail = "[Transaction Siblings] GetTransactionSiblingsDetailFail"
}

export class GetTransactionSiblingsDetailAction implements Action {

    constructor(public tokens: string[]) { }

    readonly type = ActionTypes.GetTransactionSiblingsDetail;
}

export class GetTransactionSiblingsDetailSucceedAction implements Action {

    constructor(public record: TransactionDetailDto[]) { }

    readonly type = ActionTypes.GetTransactionSiblingsDetailSucceed;
}

export class GetTransactionSiblingsDetailFailAction implements Action {

    constructor(public error: any) { }

    readonly type = ActionTypes.GetTransactionSiblingsDetailFail;
}
